import React, { useState, useEffect } from "react";
import { Container, Spinner, Image } from "react-bootstrap";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import SocialBar from "../components/SocialBar";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';
import "./cursos-gratuitos.css";

const API_URL = "https://facach.coop.hn/api";

function getYtEmbed(url) {
    const match = url?.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([a-zA-Z0-9_-]{11})/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

function getYtThumb(url) {
    const match = url?.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([a-zA-Z0-9_-]{11})/);
    return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null;
}

function VideoCard({ course, onPlay }) {
    const thumb = course.cover_url || getYtThumb(course.youtube_url);
    return (
        <div className="curso-card" onClick={() => onPlay(course)}>
            <div className="curso-card-thumb">
                {thumb ? (
                    <img src={thumb} alt={course.title} className="curso-thumb-img" />
                ) : (
                    <div className="curso-thumb-placeholder">▶</div>
                )}
                <div className="curso-play-overlay">
                    <div className="curso-play-btn">▶</div>
                </div>
            </div>
            <div className="curso-card-body">
                <div className="curso-card-title">{course.title}</div>
                {course.description && (
                    <div className="curso-card-desc">{course.description}</div>
                )}
            </div>
        </div>
    );
}

export default function CursosGratuitos() {
    const { settings } = useSiteSettings();
    const bannerSrc = settings.banner_image
        ? `https://facach.coop.hn${settings.banner_image}`
        : fallbackBanner;

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [playing, setPlaying] = useState(null);
    const [catFilter, setCatFilter] = useState('all');
    const [q, setQ] = useState('');

    useEffect(() => {
        const fetch_ = async () => {
            try {
                const res = await fetch(`${API_URL}/free-courses`);
                const json = await res.json();
                if (json.ok) setData(json.data || []);
            } catch (err) {
                console.error("Error cargando cursos:", err.message);
            } finally { setLoading(false); }
        };
        fetch_();
    }, []);

    const filtered = data
        .filter(cat => catFilter === 'all' || String(cat.id) === catFilter)
        .map(cat => ({
            ...cat,
            courses: cat.courses.filter(c =>
                c.title.toLowerCase().includes(q.toLowerCase()) ||
                (c.description || '').toLowerCase().includes(q.toLowerCase())
            ),
        }))
        .filter(cat => cat.courses.length > 0);

    const totalCursos = data.reduce((acc, cat) => acc + cat.courses.length, 0);

    return (
        <div className="cursos-page">
            <NavbarFacach />

            {/* Banner especial */}
            {/* Banner */}
            <div className="banner-wrapper">
                <Image src={bannerSrc} alt="Cursos Gratuitos - FACACH" fluid className="banner-image" />
                <div className="banner-overlay">
                    <h1 className="banner-title">CURSOS GRATUITOS</h1>
                    <p className="banner-description">
                        Aprende a tu ritmo con nuestros videos educativos para el sector cooperativo
                    </p>
                </div>
            </div>

            {/* Stats debajo del banner */}
            <div style={{
                background: "linear-gradient(135deg, #1a3a6b)",
                padding: "20px 24px",
                display: "flex",
                justifyContent: "center",
                gap: 40,
                flexWrap: "wrap",
            }}>
                {[
                    { num: totalCursos, label: "Videos" },
                    { num: data.length, label: "Categorías" },
                    { num: "100%", label: "Gratuito" },
                ].map((s, i) => (
                    <div key={i} style={{ textAlign: "center" }}>
                        <div style={{ fontSize: 24, fontWeight: 900, color: "rgba(255,255,255,0.75)", lineHeight: 1 }}>{s.num}</div>
                        <div style={{ fontSize: 11, color: "rgba(255,255,255,0.75)", fontWeight: 600, marginTop: 2 }}>{s.label}</div>
                    </div>
                ))}
            </div>

            <Container className="cursos-container">

                {/* Búsqueda y filtros */}
                <div className="cursos-filters">
                    <div className="cursos-search-wrap">
                        <span className="cursos-search-icon">🔍</span>
                        <input
                            className="cursos-search"
                            placeholder="Buscar curso o video…"
                            value={q}
                            onChange={e => setQ(e.target.value)}
                        />
                    </div>
                    <div className="cursos-cat-chips">
                        {[{ id: 'all', name: 'Todos' }, ...data].map(cat => (
                            <button key={cat.id}
                                className={`cursos-chip ${catFilter === String(cat.id) ? 'active' : ''}`}
                                onClick={() => setCatFilter(String(cat.id))}
                            >{cat.name}</button>
                        ))}
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="danger" />
                    </div>
                ) : filtered.length === 0 ? (
                    <div className="cursos-empty">
                        <div style={{ fontSize: 48, marginBottom: 12 }}>🎬</div>
                        <div style={{ fontSize: 18, fontWeight: 700, color: "#1a3a6b" }}>Sin resultados</div>
                        <div style={{ fontSize: 14, marginTop: 4 }}>Intenta con otro término</div>
                    </div>
                ) : (
                    filtered.map(cat => (
                        <div key={cat.id} className="cursos-category">
                            <div className="cursos-category-header">
                                <div className="cursos-category-dot" />
                                <h2 className="cursos-category-title">{cat.name}</h2>
                                <span className="cursos-category-count">{cat.courses.length} videos</span>
                            </div>
                            {cat.description && (
                                <p className="cursos-category-desc">{cat.description}</p>
                            )}
                            <div className="cursos-grid">
                                {cat.courses.map(course => (
                                    <VideoCard key={course.id} course={course} onPlay={setPlaying} />
                                ))}
                            </div>
                        </div>
                    ))
                )}
            </Container>

            {/* Modal video */}
            {playing && (
                <div className="cursos-modal-overlay" onClick={() => setPlaying(null)}>
                    <div className="cursos-modal" onClick={e => e.stopPropagation()}>
                        <button className="cursos-modal-close" onClick={() => setPlaying(null)}>✕</button>
                        <div className="cursos-modal-video">
                            {getYtEmbed(playing.youtube_url) ? (
                                <iframe
                                    src={`${getYtEmbed(playing.youtube_url)}?autoplay=1`}
                                    title={playing.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{ width: "100%", height: "100%", borderRadius: "12px 12px 0 0" }}
                                />
                            ) : (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#fff", fontSize: 16 }}>
                                    URL de YouTube no válida
                                </div>
                            )}
                        </div>
                        <div className="cursos-modal-info">
                            <div className="cursos-modal-title">{playing.title}</div>
                            {playing.description && <div className="cursos-modal-desc">{playing.description}</div>}
                        </div>
                    </div>
                </div>
            )}

            <SocialBar position="right" top="35%" size={42} rounded={true} />
            <FooterFacach />
        </div>
    );
}